import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import { icon } from './ui';
export default class Hero extends Component {
  view() {
    const baseUrl = String(app.forum.attribute('baseUrl') || '').replace(/\/$/, '');
    const title = app.forum.attribute('novatruckHeroTitle') || 'WITAJ W NOVATRUCK & RP';
    const subtitle = app.forum.attribute('novatruckHeroSubtitle') || 'Truck • RPG • Light RP • Ekonomia';
    const address = String(app.forum.attribute('novatruckServerAddress') || '51.83.182.99:20236').replace(/^mtasa:\/\//i, '');
    const joinUrl = `mtasa://${address}`;
    return m("section", {
      className: "NtHero",
      "aria-labelledby": "nt-hero-title",
      style: {
        backgroundImage: `url(${baseUrl}/assets/extensions/novatruck-theme/hero.webp)`
      }
    }, m("div", {
      className: "NtHero-overlay"
    }), m("div", {
      className: "container NtHero-content"
    }, m("p", {
      className: "NtHero-eyebrow"
    }, "NOVA TRUCK COMMUNITY"), m("h1", {
      id: "nt-hero-title"
    }, title), m("p", {
      className: "NtHero-subtitle"
    }, subtitle), m("a", {
      className: "Button Button--primary NtHero-cta",
      href: joinUrl
    }, m("span", null, "DO\u0141\u0104CZ DO GRY"), icon('fas fa-arrow-right'))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/Hero', Hero);